module.exports = __webpack_public_path__ + "img/banner1.05f41e43.jpg";